const HorseRacingModule = () => import(/* webpackChunkName: "horse-race-module" */ './views/Module.vue');
const HorseRacing = () => import(/* webpackChunkName: "HorseRacing" */ './views/HorseRacing.vue');
const HorseRaceEventDetails = () => import(/* webpackChunkName: "HorseRaceEventDetails" */ './views/HorseRaceEventDetails.vue');
const HorseRacingRoutes =
{
    path: '/',
    component: HorseRacingModule,
    children: [
        {
            path: 'horse-racing',
            name: 'HorseRacing',
            component: HorseRacing,
        },
        {
            path: 'horse-race-event-details/:eventId',
            name: 'HorseRaceEventDetails',
            component: HorseRaceEventDetails,
        }
    ],
}

export default HorseRacingRoutes;